module.exports = "<div class=box> <div class=\"breadcrumb exo p-h-lg\"> <div> <ui-breadcrumbs displayname-property=data.displayName abstract-proxy-property=data.proxy template-url=ngBreadCrumbTemplate.html></ui-breadcrumbs> </div> </div> <div class=\"box-row content-box\"> <div class=box-cell> <div class=\"box-inner padding-box no-padding\" ui-view id=view> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/layout/content.html
// module id = 169
// module chunks = 0